import { IAuthUserPerfil } from './auth/IAuthUserPerfil';
import { toCapitalize } from 'utils/StringUtils';
import { AUTH_ACTIONS_LOGOUT, AUTH_ACTIONS_LOGIN, AuthActionTypes, AUTH_ACTIONS_REGISTER_REDIRECT_PATH } from "./AuthActionTypes";

export interface IAuthByToken {
  coops: string[];
  ldap: string;
  nome: string;
  tokenWs: string;
}

export interface IAuthUserReducer {
  nome: string;
  cpfCnpj: string;
  perfil: IAuthUserPerfil;
  coops?: string[];
  ladpAccessToken?: string;
  associadoAccessToken?: string;
  tokenWs?: string;
}

export interface IAuthReducer {
  logged: boolean;
  usuario?: IAuthUserReducer;
  redirectPath?: string;
}

const INITIAL_STATE: IAuthReducer = {
  logged: false,
}

const getNormalizedUsuario = (usuario?: IAuthUserReducer): IAuthUserReducer | undefined => {
  if (usuario) {
    return {
      ...usuario,
      nome: toCapitalize(usuario.nome, true) 
    }
  }
  return usuario;
}

export default (state: IAuthReducer = INITIAL_STATE, action: AuthActionTypes) => {
  switch (action.type) {
    case AUTH_ACTIONS_REGISTER_REDIRECT_PATH:
      return { ...state, redirectPath: action.payload };
    case AUTH_ACTIONS_LOGIN:
      return { ...state, usuario: getNormalizedUsuario(action.payload), logged: true }
    case AUTH_ACTIONS_LOGOUT:
      return { ...state, usuario: undefined, logged: false, redirectPath: undefined };
    default:
      return state;
  }
};